import {
  isXiaomaiApp,
  isXiaoMaiIOSApp,
  isXiaoMaiAndroidApp
} from '@/common/utils/getPlaform';

class Bridge {
  constructor() {
    if (!isXiaomaiApp()) return;
    this.setup(() => { });
  }

  setup(callback: Function) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  }

  callHandler(readyCallback: Function, errorCallback = () => { }) {
    if (!isXiaomaiApp()) {
      return;
    }
    if (isXiaoMaiIOSApp()) {
      if (window.WebViewJavascriptBridge) {
        readyCallback(new API(errorCallback));
      } else {
        document.addEventListener('WebViewJavascriptBridgeReady', () => {
          readyCallback(new API(errorCallback));
        });
      }
    } else if (isXiaoMaiAndroidApp()) {
      readyCallback(new API(errorCallback));
    } else {
      readyCallback();
    }
  }

}

class API {
  NativeBridge: any;
  constructor(errorCallback: Function) {
    if (isXiaoMaiIOSApp()) {
      if (window.WebViewJavascriptBridge) {
        this.NativeBridge = window.WebViewJavascriptBridge;
      } else {
        errorCallback('IOS', 'IOS 初始化失败');
      }
    } else if (isXiaoMaiAndroidApp()) {
      if (window.Android) {
        this.NativeBridge = window.Android;
      } else {
        errorCallback('Android', 'Android 初始化失败');
      }
    }
  }

  callContact = (params: any, callback = () => { }) => {
    const str = JSON.stringify(params)
    if (isXiaoMaiIOSApp()) {
      this.NativeBridge.callHandler('callContact', str, callback);
    } else if (isXiaoMaiAndroidApp()) {
      (window as Window).callContactCallback = callback;
      this.NativeBridge.callContact('callContactCallback', str);
    }
  }

  openUrl = (params: any, callback = () => { }) => {
    const str = JSON.stringify(params)
    if (isXiaoMaiIOSApp()) {
      this.NativeBridge.callHandler('openUrl', str, callback);
    } else if (isXiaoMaiAndroidApp()) {
      (window as Window).openUrlCallback = callback;
      this.NativeBridge.openUrl('openUrlCallback', str);
    }
  }

  exit = (params: any, callback = () => { }) => {
    const str = JSON.stringify(params)
    if (isXiaoMaiIOSApp()) {
      this.NativeBridge.callHandler('exit', str, callback);
    } else if (isXiaoMaiAndroidApp()) {
      (window as Window).exitCallback = callback;
      this.NativeBridge.exit('exitCallback', str);
    }
  }

  // 时间选择器
  timePicker = (params: any, callback = () => {}) => {
    const str = JSON.stringify(params);
    (window as Window).timePickerCallback = callback;
    this.NativeBridge.timePicker('timePickerCallback', str);
  }
 
}

export default new Bridge();